import type { TMessages } from '@/types/TMessages'

export const messages = {
  notice: 'Лоты не найдены',
  title: 'Создайте заявку с желаемой ценой продажи',
  description: 'Так как еще нет предложений от закупщиков данной культуры.',
} satisfies TMessages
